import React, { useCallback } from 'react'

import type { IControlProps } from 'components/controls/Field/Field.types'
import type { ICheckboxProps, CheckboxValue } from 'components/uiKit/Checkbox'
import Checkbox from 'components/uiKit/Checkbox'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldCheckbox = <V extends CheckboxValue>({
  name,
  onChange,
  value,
  defaultValue,
  ...rest
}: IControlProps<ICheckboxProps<V>>) => {
  const handleChange = useCallback((value: V) => onChange({ value, name }), [name, onChange])

  return <Checkbox name={name} onChange={handleChange} {...rest} value={value ?? defaultValue} />
}

export default FieldCheckbox
